const { default: Swiper } = require("swiper");
const {
  default: PopularPosts,
} = require("../../src/js/components/popularPosts");
const { default: Comments } = require("../../src/js/components/comments");

class PostContent {
  constructor() {
    this.sliderInit();
    new PopularPosts();
    new Comments();
  }
  sliderInit = () => {
    const similarSlider = new Swiper(".js-similar-slider", {
      slidesPerView: "auto",
      spaceBetween: 20,
    });
    const commentSlider = new Swiper(".js-comment-slider", {
      slidesPerView: "auto",
      spaceBetween: 20,
    });
  };
}

new PostContent();
